import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mt-6" }
const _hoisted_2 = { class: "columns" }
const _hoisted_3 = { class: "column" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "column is-narrow" }, [
  /*#__PURE__*/_createVNode("button", {
    type: "submit",
    class: "button is-dark"
  }, "Save")
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon-text" }, [
  /*#__PURE__*/_createVNode("span", { class: "icon" }, [
    /*#__PURE__*/_createVNode("i", { class: "fas fa-spin fa-sync-alt" })
  ]),
  /*#__PURE__*/_createVNode("span", null, "Loading...")
], -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "label mt-4" }, "Name*", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "label mt-4" }, "Users", -1)
const _hoisted_12 = { class: "table is-bordered is-fullwidth is-narrow mt-4" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/_createVNode("td", null, "No users", -1)
const _hoisted_15 = { class: "is-narrow p-0" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fas fa-trash" }, null, -1)
const _hoisted_17 = { class: "select" }
const _hoisted_18 = /*#__PURE__*/_createVNode("option", {
  selected: "",
  value: undefined
}, "Select user", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_in_table = _resolveComponent("user-in-table")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("form", {
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"])),
      class: "section"
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$route.params.id ? 'Edit' : 'Add') + " Team", 1)
        ]),
        _hoisted_5
      ]),
      _hoisted_6,
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock("div", _hoisted_7, [
            _hoisted_8
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_9, [
            (_ctx.errorMessage)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: "has-text-danger",
                  textContent: _toDisplayString(_ctx.errorMessage)
                }, null, 8, ["textContent"]))
              : _createCommentVNode("", true),
            _hoisted_10,
            _withDirectives(_createVNode("input", {
              type: "text",
              class: "input",
              placeholder: "e.g. Panowie Programiści",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.team.name = $event))
            }, null, 512), [
              [_vModelText, _ctx.team.name]
            ]),
            _hoisted_11,
            _createVNode("table", _hoisted_12, [
              _createVNode("tbody", null, [
                (!_ctx.team.users.length)
                  ? (_openBlock(), _createBlock("tr", _hoisted_13, [
                      _hoisted_14
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.team.users, (user) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: user.id
                  }, [
                    _createVNode(_component_user_in_table, {
                      user: user,
                      class: "is-vcentered"
                    }, null, 8, ["user"]),
                    _createVNode("td", _hoisted_15, [
                      _createVNode("button", {
                        type: "button",
                        class: "button is-danger is-inverted",
                        onClick: ($event: any) => (_ctx.removeUser(user.id))
                      }, [
                        _hoisted_16
                      ], 8, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createVNode("div", null, [
              _createVNode("div", _hoisted_17, [
                _withDirectives(_createVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.selectedUser = $event))
                }, [
                  _hoisted_18,
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                    return (_openBlock(), _createBlock("option", {
                      value: user.id,
                      key: user.id
                    }, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 9, ["value"]))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _ctx.selectedUser]
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "button is-dark ml-4",
                disabled: !_ctx.selectedUser,
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addUser && _ctx.addUser(...args)))
              }, " Add user ", 8, ["disabled"])
            ])
          ]))
    ], 32)
  ]))
}